module.exports = __webpack_public_path__ + "img/resume-editor.08d1836a.svg";